/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, Map, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,

  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILURE,

  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,

  SET_DISPLAY_OPTIONS,
} from './action-types.js';

import {
  SAVE_TEMPLATE_ICON_SUCCESS,
  SAVE_TEMPLATE_ICON_FAILURE,
} from 'modules/icons/action-types.js';


import { Options, type EnclaveTemplate } from './types.js';
import type { RawOptions } from './types.js';

type State = OrderedMap<string, EnclaveTemplate>;

export const templates = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
    return payload;
  case SAVE_SUCCESS:
    return state.set(payload.id, payload);
  case SAVE_TEMPLATE_ICON_SUCCESS:
    const fieldToSave = payload.iconUrl.includes('.svg') ? 'iconSvgUrl' : 'iconUrl';
    return state.setIn([payload.guid, fieldToSave], payload.iconUrl);
  case DELETE_SUCCESS:
    return state.delete(payload);
  default:
    return state;
  }
};

export const options = (state: typeof Options = Options(), action: Action<RawOptions>) => {
  const { type, payload } = action;

  switch (type) {
  case SET_DISPLAY_OPTIONS:
    return state.merge(payload);
  default:
    return state;
  }
};

export const loading = (state: boolean = true, action: Action<any>) => {
  switch (action.type) {
  case FETCH:
  case SAVE:
  case DELETE:
    return true;
  case FETCH_SUCCESS:
  case FETCH_FAILURE:
  case SAVE_SUCCESS:
  case SAVE_FAILURE:
  case DELETE_SUCCESS:
  case DELETE_FAILURE:
  case SAVE_TEMPLATE_ICON_SUCCESS:
  case SAVE_TEMPLATE_ICON_FAILURE:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  templates,
  loading,
  options,
});




// WEBPACK FOOTER //
// ./src/app/modules/templates/stores.js